import React, { useState } from 'react';
import { Briefcase, TrendingUp, Users, Award, Send } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { careerInfo } from '../mockData';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CareerPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    position: '',
    message: '',
    resume: null
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your interest! We will review your application and contact you shortly.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      position: '',
      message: '',
      resume: null
    });
  };

  function fullwindowpopup(){
    window.open("newpopup.html","bfs","fullscreen,scrollbars")
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-white z-0"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6">
            <h1 className="text-5xl font-bold mb-6" style={{ color: 'rgb(8, 120, 191)' }}>
              Start Your Career With
            </h1>
                <div className="text-center">
                  <img
                    src="/FMAL_Logo_Transparent.png" 
                    alt="Find Me A Lender" 
                    class="h-20 w-auto img-fluid mx-auto d-block"
                  />
                </div>
            </h1>
            <h2 className="text-4xl font-bold text-center mb-6" style={{ color: ["#3E4D66"] }}>
              Currently, we do not have any job openings available. Please check again another time!
            </h2>
{/*
            <p className="text-xl text-gray-600 mb-8">
              Join Australia's leading mortgage brokering team and make a real difference in people's lives
            </p>
            <Button 
              size="lg" 
              style={{ backgroundColor: '#0878BF' }}
              className="text-white hover:opacity-90 transition-opacity text-lg px-8 py-6"              
              onClick={() => document.getElementById('application-form').scrollIntoView({ behavior: 'smooth' })} 
            >
              Apply Now
            </Button>
*/}
          </div>
        </div>
      </section>

      {/* About Working With Us */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-12">
              <div>
                <img 
                  src="/startyourcareer.jpg"
                  alt="Start your career with Find Me A Lender"
                  className="rounded-2xl shadow-lg w-full h-auto"
                />
              </div>
              <div className="space-y-4">
                <h2 className="text-4xl font-bold" style={{ color: '#0878BF' }}>
                  {careerInfo.title}
                </h2>
                <p className="text-lg text-gray-700">
                  {careerInfo.introduction}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold text-center mb-6" style={{ color: '#0878BF' }}>
              Why Join Our Team?
            </h2>
            <p className="text-lg text-gray-600 text-center mb-12">
              We offer more than just a job - we offer a rewarding career
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {careerInfo.benefits.map((benefit, index) => (
                <Card key={index} className="border-2 hover:shadow-lg transition-shadow">
                  <CardHeader>
                    <div className="flex items-start space-x-3">
                      <div 
                        className="p-2 rounded-lg flex-shrink-0"
                        style={{ backgroundColor: '#0878BF' }}
                      >
                        {index % 4 === 0 && <Briefcase className="h-5 w-5 text-white" />}
                        {index % 4 === 1 && <TrendingUp className="h-5 w-5 text-white" />}
                        {index % 4 === 2 && <Users className="h-5 w-5 text-white" />}
                        {index % 4 === 3 && <Award className="h-5 w-5 text-white" />}
                      </div>
                      <p className="text-gray-700 leading-relaxed">{benefit}</p>
                    </div>
                  </CardHeader>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Available Roles */}
{/*}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold text-center mb-6" style={{ color: '#0878BF' }}>
              Current Opportunities
            </h2>
            <p className="text-lg text-gray-600 text-center mb-12">
              Explore career opportunities in our growing team
            </p>
            
            <div className="space-y-6">
              {careerInfo.roles.map((role, index) => (
                <Card key={index} className="border-2 hover:shadow-xl transition-shadow">
                  <CardHeader>
                    <CardTitle className="text-2xl" style={{ color: '#0878BF' }}>
                      {role.title}
                    </CardTitle>
                    <CardDescription className="text-base text-gray-700 mt-4">
                      {role.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <Button 
                      variant="outline"
                      style={{ borderColor: '#0878BF', color: '#0878BF' }}
                      onClick={() => {
                        setFormData({ ...formData, position: role.title });
                        document.getElementById('application-form').scrollIntoView({ behavior: 'smooth' });
                      }}
                    >
                      Apply for this role
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>
*/}
      {/* Success Story / Culture */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div className="space-y-6">
                <h2 className="text-4xl font-bold" style={{ color: '#0878BF' }}>
                  Our Culture
                </h2>
                <p className="text-lg text-gray-700">
                  At Find Me A Lender, we believe in creating a supportive, collaborative environment where everyone can thrive. We're more than colleagues - we're a family dedicated to helping Australians achieve their financial dreams.
                </p>
                <p className="text-lg text-gray-700">
                  We value integrity, expertise, and genuine care for our clients. If you share these values and want to build a meaningful career in finance, we'd love to hear from you.
                </p>
                <div className="grid grid-cols-2 gap-4 pt-4">
                  <div className="text-center p-4 bg-white rounded-lg shadow">
                    <p className="text-3xl font-bold" style={{ color: '#0878BF' }}>15+</p>
                    <p className="text-gray-600 text-sm">Years Experience</p>
                  </div>
                  <div className="text-center p-4 bg-white rounded-lg shadow">
                    <p className="text-3xl font-bold" style={{ color: '#0878BF' }}>50+</p>
                    <p className="text-gray-600 text-sm">Lender Partners</p>
                  </div>
                  <div className="text-center p-4 bg-white rounded-lg shadow">
                    <p className="text-3xl font-bold" style={{ color: '#0878BF' }}>1000+</p>
                    <p className="text-gray-600 text-sm">Happy Clients</p>
                  </div>
                  <div className="text-center p-4 bg-white rounded-lg shadow">
                    <p className="text-3xl font-bold" style={{ color: '#0878BF' }}>5★</p>
                    <p className="text-gray-600 text-sm">Google Rating</p>
                  </div>
                </div>
              </div>
              <div>
                <img 
                  src="/aboutus.jpg"
                  alt="Team culture, Ginny and Dilpreet smiling as they work on a case together"
                  className="rounded-2xl shadow-lg w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Application Form */}
{/*      <section id="application-form" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold mb-4" style={{ color: '#0878BF' }}>
                Apply Now
              </h2>
              <p className="text-lg text-gray-600">
                Take the first step towards an exciting career with Find Me A Lender
              </p>
            </div>
            
             <Card className="border-2 shadow-xl">
              <CardContent className="pt-6">
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <Label htmlFor="name">Full Name *</Label>
                      <Input
                        id="name"
                        type="text"
                        required
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        className="mt-2"
                        placeholder="John Smith"
                      />
                    </div>
                    
                    <div>
                      <Label htmlFor="email">Email *</Label>
                      <Input
                        id="email"
                        type="email"
                        required
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        className="mt-2"
                        placeholder="john@example.com"
                      />
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <Label htmlFor="phone">Phone Number *</Label>
                      <Input
                        id="phone"
                        type="tel"
                        required
                        value={formData.phone}
                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                        className="mt-2"
                        placeholder="0400 000 000"
                      />
                    </div>
                    
                    <div>
                      <Label htmlFor="position">Position of Interest *</Label>
                      <Input
                        id="position"
                        type="text"
                        required
                        value={formData.position}
                        onChange={(e) => setFormData({ ...formData, position: e.target.value })}
                        className="mt-2"
                        placeholder="Mortgage Broker"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <Label htmlFor="message">Cover Letter / Message *</Label>
                    <Textarea
                      id="message"
                      required
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      className="mt-2"
                      rows={6}
                      placeholder="Tell us why you'd be a great fit for our team..."
                    />
                  </div>
                  
                  <div>
                    <Label htmlFor="resume">Resume / CV</Label>
                    <Input
                      id="resume"
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={(e) => setFormData({ ...formData, resume: e.target.files[0] })}
                      className="mt-2"
                    />
                    <p className="text-sm text-gray-500 mt-1">
                      Accepted formats: PDF, DOC, DOCX (Max 5MB)
                    </p>
                  </div>
                  
                  <Button 
                    type="submit"
                    size="lg"
                    className="w-full text-white"
                    style={{ backgroundColor: '#0878BF' }}
                  >
                    Submit Application
                    <Send className="ml-2 h-5 w-5" />
                  </Button>
                </form>
              </CardContent>
            </Card>


            <div className="mt-8 text-center">
              <p className="text-gray-600">
                Contact us at{' '}
                <a 
                  href="mailto:careers@findmealender.com.au" 
                  className="font-medium hover:underline"
                  style={{ color: '#0878BF' }}
                >
                  info@findmealender.com.au
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
  */}
      <Footer />
    </div>
  );
};

export default CareerPage;
